"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayOrQuitFollowupDate = exports.PAY_OR_QUIT_FOLLOWUP_DATES = exports.NOTIFICATION_TYPES = exports.LATE_PAYMENT_REASONS = void 0;
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
const dates_1 = require("./dates");
const regions_1 = require("./regions");
exports.LATE_PAYMENT_REASONS = {
    PAID_MID_MONTH: 'paid_mid_month',
    LOST_JOB: 'lost_job',
    MEDICAL_ISSUES: 'medical_issues',
    DEATH_IN_FAMILY: 'death_in_family',
    DIVORCE: 'divorce',
    FAMILY_CIRCUMSTANCES_CHANGED: 'family_circumstances_changed',
    IN_COURT_PROCEEDINGS: 'in_court_proceedings',
    OTHER: 'other'
};
exports.NOTIFICATION_TYPES = {
    PAY_OR_QUIT: 'pay_or_quit',
    PROMISED_TO_PAY_TOMORROW: 'promised_to_pay_tomorrow',
    MISSED_PROMISE_TO_PAY: 'missed_promise_to_pay'
};
exports.PAY_OR_QUIT_FOLLOWUP_DATES = {
    [regions_1.STATES.AL]: {
        type: 'business',
        days: 8
    },
    [regions_1.STATES_FULL.AL]: {
        type: 'business',
        days: 8
    },
    [regions_1.STATES.GA]: {
        type: 'business',
        days: 4
    },
    [regions_1.STATES_FULL.GA]: {
        type: 'business',
        days: 4
    },
    [regions_1.STATES.IN]: {
        type: 'calendar',
        days: 11
    },
    [regions_1.STATES_FULL.IN]: {
        type: 'calendar',
        days: 11
    },
    [regions_1.STATES.MO]: {
        type: 'business',
        days: 11
    },
    [regions_1.STATES_FULL.MO]: {
        type: 'business',
        days: 11
    },
    [regions_1.STATES.NC]: {
        type: 'calendar',
        days: 11
    },
    [regions_1.STATES_FULL.NC]: {
        type: 'calendar',
        days: 11
    }
};
const getPayOrQuitFollowupDate = (state, date = new Date()) => {
    const payOrQuitConfig = exports.PAY_OR_QUIT_FOLLOWUP_DATES[state];
    if (!payOrQuitConfig) {
        return;
    }
    const { type, days } = payOrQuitConfig;
    let followupDate;
    if (type === 'business') {
        followupDate = (0, date_fns_1.addBusinessDays)(date, days);
    }
    else {
        followupDate = (0, date_fns_1.addDays)(date, days);
    }
    // set time of day to 9AM Eastern - helps for scheduling emails
    return (0, date_fns_1.setHours)((0, date_fns_tz_1.utcToZonedTime)(followupDate, dates_1.TIME_ZONES.EASTERN), 9);
};
exports.getPayOrQuitFollowupDate = getPayOrQuitFollowupDate;
